<template>
	<section class="section-table">
		<pagination
			class="pagination-top"
			:total="applicationNotification.total"
			:page.sync="applicationNotification.current_page"
			:limit.sync="applicationNotification.per_page"
			@pagination="getApplicationNotification(false)"
			@sizeChange="getApplicationNotification(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
			:slotStacked="true"
			slotPosition="before"
		>
			<section class="w-100">
				<div class="w-100 d-flex justify-content-between">
					<el-input clearable style="margin-left: 10px" size="small" v-model="search" placeholder="Search Messages"></el-input>
					<el-date-picker
						style="margin-left: 10px; width: 750px"
						v-model="filterDate"
						type="datetimerange"
						:picker-options="pickerOptions"
						range-separator="To"
						start-placeholder="Start date"
						end-placeholder="End date"
						align="right"
						size="small"
					></el-date-picker>
					<el-button style="margin-left: 10px" size="small" type="primary" @click="getApplicationNotification(true)">
						Reload History
					</el-button>
				</div>
			</section>
		</pagination>

		<el-table border v-loading="tableLoading" :data="tableData" style="width: 100%">
			<el-table-column sortable prop="message" label="Message">
                <template slot-scope="scope">
                    <span v-html="scope.row.message"></span>
                </template>
            </el-table-column>
			<el-table-column sortable prop="user.full_name" label="User" width="300">
				<template slot-scope="scope">
					{{ _.get(scope, "row.user.full_name", "Unknown") }}
				</template>
			</el-table-column>
			<el-table-column sortable prop="created_at" label="Created" width="200" :formatter="formatDate"></el-table-column>
			<el-table-column sortable prop="deleted_at" label="Trashed" width="200" :formatter="formatDate">
            </el-table-column>
		</el-table>

		<pagination
			class="pagination-bottom"
			:total="applicationNotification.total"
			:page.sync="applicationNotification.current_page"
			:limit.sync="applicationNotification.per_page"
			@pagination="getApplicationNotification(false)"
			@sizeChange="getApplicationNotification(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
			:slotStacked="true"
			slotPosition="after"
		>
			<section class="w-100">
				<div class="w-100 d-flex justify-content-between">
					<el-input clearable style="margin-left: 10px" size="small" v-model="search" placeholder="Search Messages"></el-input>
                    <el-date-picker
						style="margin-left: 10px; width: 750px"
						v-model="filterDate"
						type="datetimerange"
						:picker-options="pickerOptions"
						range-separator="To"
						start-placeholder="Start date"
						end-placeholder="End date"
						align="right"
						size="small"
					></el-date-picker>
					<el-button style="margin-left: 10px" size="small" type="primary" @click="getApplicationNotification(true)">
						Reload History
					</el-button>
				</div>
			</section>
		</pagination>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	import Pagination from "@shared/components/pagination"

	export default {
		name: "HistoryNotification",

		components: {
			Pagination,
		},

		data() {
			return {
				tableLoading: true,
				applicationNotification: [],
				search: "",
				searchTimeout: null,
				searchTimeoutWait: 1000,
				filterDate: [],
				pickerOptions: {
					shortcuts: [
						{
							text: "Last week",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
								picker.$emit("pick", [start, end])
							},
						},
						{
							text: "Last month",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
								picker.$emit("pick", [start, end])
							},
						},
						{
							text: "Last 3 months",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
								picker.$emit("pick", [start, end])
							},
						},
					],
				},
			}
		},

		computed: {
			...mapGetters({
				user: "user/user",
			}),
			tableData() {
				if (_.isEmpty(this.applicationNotification.data)) return
				return this.applicationNotification.data
			},
            filterDateRange() {
                if (_.isEmpty(this.filterDate)) return false
                return this.filterDate
            },
		},

		mounted() {
			this.getApplicationNotification(true)
		},

		methods: {
			formatDate(row, column, value, index) {
				if (value) return this.$moment.utc(value).tz(this.user.timezone).format("ddd DD/MM/YY LT")
				else return ""
			},
			getApplicationNotification(resetPage) {
				this.tableLoading = true

				if (resetPage) {
					this.applicationNotification.current_page = 1
				}

				let data = {
					page: this.applicationNotification.current_page,
					per_page: this.applicationNotification.per_page,
					search: this.search,
                    filterDateRange: this.filterDateRange
				}

				axios
					.post("/api/application/" + applicationId + "/get-application-notification", data, {
						headers: { Authorization: "Bearer " + this.$store.getters.token },
					})
					.then((res) => {
						this.applicationNotification = res.data
						this.tableLoading = false
					})
					.catch((err) => {
						console.error(err)
					})
			},
		},

		watch: {
			search: {
				handler() {
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.getApplicationNotification(true)
					}, this.searchTimeoutWait)
				},
			},
            filterDateRange: {
                handler() {
                    if (this.searchTimeout) clearTimeout(this.searchTimeout)
                    this.searchTimeout = setTimeout(() => {
                        this.getApplicationNotification(true)
                    }, this.searchTimeoutWait)
                }
            }
		},
	}
</script>

<style lang="scss" scoped>
	.section-table {
		background-color: #f0f3f5;
		border: 1px solid #c2cfd6;
		padding: 10px;

		.pagination-container {
			border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;

			&.pagination-top {
				margin-bottom: 10px !important;
			}

			&.pagination-bottom {
				margin-top: 10px !important;
				margin-bottom: 0 !important;
			}

			.el-pager {
				li {
					background-color: transparent;
					border: 1px solid #dcdfe6;
					font-weight: 400;

					&.active {
						background-color: #69c23a;
						border: none;
					}
				}
			}
		}

		.el-table {
			border: 1px solid #dcdfe6;
			border-radius: 5px;

			.el-table__row {
				cursor: pointer;

				&.account-suspended {
					td,
					th {
						.el-dropdown {
							.el-button {
								background: red;
								color: #ffffff !important;
							}
						}
					}
				}
			}

			.el-table__expanded-cell {
				background: #ffffff;
				box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.7) inset;
			}

			.cell {
				word-break: break-word;
			}
		}
	}
</style>
